import PaymentRequestsTableColumnStatus from './index.vue'
export default PaymentRequestsTableColumnStatus